import { StarIcon } from '@/assets/icons';
import Typography from '@/components/common/Typography';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { ReviewCardProps } from '../../types/product';

const ReviewCard = ({
  // reviewTitle,
  id,
  marketProductName,
  reviewContent,
  thumbnailUrl,
  price,
  originPrice,
  discountRate,
  reviewRate,
}: ReviewCardProps) => {
  const router = useRouter();

  const handleClick = () => {
    router.push(`/market/product/${id}`);
  };

  return (
    <CardContainer onClick={handleClick}>
      <ImageWrapper>
        <ProductImage src={thumbnailUrl} />
        <Overlay>
          <ReviewWrapper>
            <ReviewContent>
              <Typography variant="b1" color="white" ellipsisLines={4}>
                {reviewContent}
              </Typography>
            </ReviewContent>
          </ReviewWrapper>
        </Overlay>
      </ImageWrapper>
      <CardContent>
        <Typography variant="b1">{marketProductName}</Typography>
        <PriceInfo>
          {discountRate && (
            <Typography variant="h3" color="point2">
              {discountRate}%
            </Typography>
          )}
          <Typography variant="h3">{price.toLocaleString()}</Typography>
          {originPrice && <OriginalPrice>{originPrice.toLocaleString()}</OriginalPrice>}
        </PriceInfo>
        <div className="rating">
          <StarIcon width={12} />
          <Typography variant="b3" color="gray900">
            {reviewRate}
          </Typography>
        </div>
      </CardContent>
    </CardContainer>
  );
};

export default ReviewCard;

const CardContainer = styled.div`
  position: relative;
  cursor: pointer;
  width: 232px; /* 기본 PC 버전 크기 */
  overflow: hidden;

  @media (max-width: 768px) {
    width: 200px; /* 태블릿에서 조금 작게 */
  }

  @media (max-width: 480px) {
    width: 180px; /* 모바일에서는 더 작게 */
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  aspect-ratio: 3 / 4; /* 가로 3 : 세로 4 비율 유지 */
  border-radius: 6px;

  overflow: hidden;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  color: white;
`;

const ReviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const ReviewContent = styled.div`
  font-size: 14px;
  opacity: 0.9;
`;

const CardContent = styled.div`
  padding: 16px;
  background: white;
  .rating {
    display: flex;
    gap: 4px;
    align-items: center;
  }
`;

const PriceInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 6px 0;
`;

const OriginalPrice = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray600};
  text-decoration: line-through;
`;

// <ReviewTitle>

// <QuoteIcon style={{ width: 16, height: 16, fill: 'white' }} />
// <Typography variant="h3" color="white">
//   {reviewTitle}
// </Typography>
// </ReviewTitle>
